// DS: i6.12
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Shrink: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg width="0" height="0" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.02 13a1 1 0 011 1v5a1 1 0 01-2 0v-2.59l-4.295 4.295a.997.997 0 01-1.41-1.41L7.61 15H5.02a1 1 0 010-2zm9.295-9.705a.997.997 0 111.41 1.41L16.43 9h2.59a1 1 0 010 2h-5a1 1 0 01-1-1V5a1 1 0 012 0v2.59z" />
      </svg>
    </IconWrap>
  );
};
Shrink.displayName = 'Shrink';

export default Shrink;
